import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'underscore';
import { Observable } from 'rxjs';
import API_URL from '../../utils/api-url-homolog';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private http: HttpClient) { }

  async getPointInfo(latLng: L.LatLng, dataLayer: string): Promise<any> {
    return this.http.post<any>(`${API_URL}/alert/map/inspect`, {
      lat: latLng?.lat,
      lng: latLng?.lng,
      layerType: dataLayer
    }).toPromise()
  }

  async getPointHistory(latLng: L.LatLng): Promise<any> {
    return this.http.get<any>(`https://plataforma.brasil.mapbiomas.org/downloads/history_point?lat=${latLng?.lat}&lng=${latLng?.lng}`).toPromise()
  }

  async getPointFireHistory(latLng: L.LatLng): Promise<any> {
    return this.http.get<any>(`https://plataforma.brasil.mapbiomas.org/downloads/history_point_fire?lat=${latLng?.lat}&lng=${latLng?.lng}`).toPromise()
  }

  getPointInfoPdf(data: any): Observable<Blob> {
    return this.http.post(`${API_URL}/alert/inspectpdfreport`, data, {
      responseType: 'blob'
    });
  }

  async checkLinkValidity(link: string): Promise<boolean> {
    link = link.replace(/{([^{}]+)}/g, (match, group) => {
      if (group === 'z') {
        return '16';
      } else {
        return '1';
      }
    });
    return this.http.get(link)
      .toPromise()
      .then(() => true)
      .catch(error => {
        if (error === 'Unauthorized') {
          return false
        } else {
          return true;
        }
        // return error
      });
  }

  getAppVersion(): string {
    return "v1"
  }
}
